import { render, staticRenderFns } from "./PmpIndex.vue?vue&type=template&id=f2289d62&"
import script from "./PmpIndex.vue?vue&type=script&lang=js&"
export * from "./PmpIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports